import React, {useEffect, useState} from 'react';
import CustomForm from "../Components/CustomForm";
import Swiper from "../Components/Swiper";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Form() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
        };

        handleResize(); // Check initial width
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`background ${isMobile ? 'header-placement' : ''}`}>
            {!isMobile && <Swiper />}
            <Navbar activeLink='form'/>
            <div className='wrapper'>

                <div className='home-title'>Данс нээлгэх хүсэлт</div>
                <CustomForm />
                <Footer isMobile={isMobile}/>
            </div>
        </div>
    );
}

export default Form;
